/**
 * Gets the translated value for an event field based on the current language
 * @param {Object} event - The event object from the database
 * @param {string} field - The field name ('name', 'subHeader', or 'description')
 * @param {string} language - The current language ('en' or 'es')
 * @returns {string} - The translated value or fallback to the original field
 */
export const getEventTranslation = (event, field, language) => {
  // If no event object, return empty string
  if (!event) return '';

  // Try to get the translation for the current language
  const translation = event?.translations?.[language]?.[field];

  // If translation exists and is not empty, return it
  if (translation && translation.trim() !== '') {
    return translation;
  }

  // Otherwise, fallback to the original field (which is English for backward compatibility)
  return event[field] || '';
};
